import { lengthContraction } from '@/domain/physics/SpecialRelativity.js'
import BlockElement from '@/domain/scene/generic/BlockElement.js'

export default class ImageBlockElement extends BlockElement {
  constructor (name, widthRel, heightRel, initXRel, initYRel, color, imageSrc, imageWidth, imageHeight) {
    super(name, widthRel, heightRel, initXRel, initYRel, color)

    this.imageSrc = imageSrc
    this.imageWidth = imageWidth
    this.imageHeight = imageHeight

    this.fillPatternImage = null
    this.fillPatternScaleX = null
    this.fillPatternScaleY = null
    this.fillPatternRepeat = 'no-repeat'
  }

  setOnScene (sceneWidth, sceneHeight, speedC = null) {
    super.setOnScene(sceneWidth, sceneHeight, speedC)

    this.fillPatternScaleX = sceneWidth * this.widthRel / this.imageWidth
    this.fillPatternScaleY = sceneHeight * this.heightRel / this.imageHeight

    if (speedC !== null) {
      this.fillPatternScaleX = lengthContraction(this.fillPatternScaleX, speedC)
    }
  }

  getConfig () {
    let config = super.getConfig()

    config.fillPatternImage = this.fillPatternImage
    config.fillPatternScaleX = this.fillPatternScaleX
    config.fillPatternScaleY = this.fillPatternScaleY
    config.fillPatternRepeat = this.fillPatternRepeat

    return config
  }

  setImage (image) {
    this.color = null
    this.fillPatternImage = image
  }
}
